/*********************** Custom JS for Boost AI Search & Discovery  ************************/
boostSDAppConfig.analytics = {
  selectorAddToCart: '.boost-sd__btn-add-to-cart, form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] *[name="add"], button.relative.w-full.uppercase.button-primary[aria-label="add to cart"],.buy-buttons input',
  selectorBuyNow: 'boost-sd__btn-buy-now, .shopify-payment-button__button, .shopify-payment-button, #dynamic-checkout-cart'
};

function getProductMetafield(productData, namespace, key) {
    if (productData.hasOwnProperty('metafields')) {
        var metafieldValue = productData['metafields'].filter(function(e) { return e.namespace == namespace && e.key == key; });
        if (typeof metafieldValue[0] !== 'undefined') {
            return metafieldValue[0]['value'];
        }
    }
    return null;
};

const customize = {
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Add custom data fields #205043',
      enabled: true,
      apply: () => ({
        afterRender(element){
          try {
          // Start customization--------------------------------------------
					let productData = element.getParams().props.product;
					let productId = productData.id;
                    let productAvailable = productData.available;
					if (productData?.split_product) {
			    productId = productData.variant_id;
					}

					let productItem = document.querySelector('[data-product-id="' + productId + '"]');
					if (productItem) {
                      let customTitle = getProductMetafield(productData, 'custom', 'displayproducttitle');
                      let styleMetafield = getProductMetafield(productData, 'custom', 'productstyle');
                      
                      if (customTitle) {
                        productItem.querySelector('.boost-sd__product-title').innerHTML = customTitle;
                      }

                      if (styleMetafield && productItem.querySelector('.boost-sd__product-vendor') && !productItem.querySelector('.boost--sd__custom-style')) {
                        let styleMetafieldHTML = `<div class="boost--sd__custom-style";>&nbsp;|&nbsp;${styleMetafield}</div>`;
                        productItem.querySelector('.boost-sd__product-vendor').insertAdjacentHTML('afterend', styleMetafieldHTML);
                      }

                      // Add start from
                      let startAtText = '<div class="boost-sd__start-at">Starting at:</div>';
                      if (!productItem.querySelector('.boost-sd__start-at')) {
                        productItem.querySelector('.boost-sd__product-price').insertAdjacentHTML('afterbegin',startAtText);
                      }

                      // Add available text (sergey)

                      // if (!productItem.querySelector('.boost--sd__custom-available')) {
                      //   let availableText = ``;
                      //   if (productAvailable) {
                      //     availableText = `In stock`
                      //   } else {
                      //     availableText = `Out of stock`
                      //   }
                      //   console.log(availableText);
                      //   productItem.querySelector('.boost-sd__product-info').insertAdjacentHTML('beforeend', `<div class="boost--sd__custom-available mt-3 border-top pt-3 text-xs product-inventory__status w-full ${productAvailable}">${availableText}</div>`);   
                      // }
                      
					}
          // End-------------------------------------------------------------
          } catch (e) {
	          console.error(e) ;
          }
        }
      }),
    });

    componentRegistry.useComponentPlugin('SearchProductItem', {
      name: 'Add custom data fields #205043',      
      apply: () => ({
        afterRender(element){
            let productData = element.getParams().props.product;
					let productId = productData.id;
					if (productData?.split_product) {
			    productId = productData.variant_id;
					}
					let productItem = document.querySelector('[data-id="' + productId + '"]');
					if (productItem) {
                      let customTitle = getProductMetafield(productData, 'custom', 'displayproducttitle');
                      let styleMetafield = getProductMetafield(productData, 'custom', 'productstyle');
                      
                      if (customTitle) {
                        productItem.querySelector('.boost-sd__suggestion-queries-item-title').innerHTML = customTitle;
                      }

                      if (styleMetafield && productItem.querySelector('.boost-sd__suggestion-queries-item-vendor') && !productItem.querySelector('.boost--sd__custom-style')) {
                        let styleMetafieldHTML = `<div class="boost--sd__custom-style";>&nbsp;|&nbsp;${styleMetafield}</div>`;
                        productItem.querySelector('.boost-sd__suggestion-queries-item-vendor').insertAdjacentHTML('afterend', styleMetafieldHTML);
                      }

                      // Add start from
                     /* let startAtText = '<div class="boost-sd__start-at">Starting at:</div>';
                      if (!productItem.querySelector('.boost-sd__start-at')) {
                        productItem.querySelector('.boost-sd__suggestion-queries-item-price').insertAdjacentHTML('afterbegin',startAtText);
                      }*/
					} 

            }
        }),
      });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);



      